import { useEffect, useState } from 'react';
import { Button, Accordion, Card, Row, Col } from 'react-bootstrap';

import GenericButton from 'src/Admin/components/common/button';
import Header from '../../common/Header/Header';
import { useLocation, useNavigate, Link, Navigate } from 'react-router-dom';
import './ApprovalRequest.scss';
import { formatDate } from 'src/Admin/utils/dates';
import EditIcon from '../../../img/myProfile/EditIcon';
import { ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import {
  AccordionDownArrow,
  AccordionUpArrow,
} from '../../../img/findcare/FindCareSVG';
import DoctorViewPanel from 'src/Admin/components/User/Personas/Providers/Doctors/DoctorView';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { axiosInstance } from 'src/api/axios';
import {
  DoctorProviderIconSVG,
  FacilityProviderIconSVG,
  DeleteIconSVG,
} from '../../../img/uploadDocument/uploadDocumentSVG';
import CommonApproveDeniedAPI from './CommonApproveDeniedAPI';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';
import ApprovalDetailsSkeleton from './ApprovalDetailsSkeleton';
import useDate from '../../../utils/useDate';
import { ApprovalIcons } from '../../../img/GlobalSVG';

const ApprovalRequest = () => {
  const location = useLocation();
  const navigate = useNavigate();
  console.log(location.state, 'approval');
  const { approveProviderData, deniedProviderData } = CommonApproveDeniedAPI();
  const [onClickEditButton, setOnClickEditButton] = useState(false);
  const [affliationData, setAffliationData] = useState();
  const [doctorFacilityFlag, setDoctorFacilityFlag] = useState();
  const [doctorProvider, setDoctorProvider] = useState();
  const [facilityProvider, setFacilityProvider] = useState();
  const [dataFetching, setDataFetching] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const { formatDate } = useDate();
  //const { userData } = useSelector((state) => state?.user);
  let { themeValuesObject } = useSelector((state) =>
    state?.theme?.branding
      ? state?.theme?.branding
      : { themeValuesObject: { 'Secondary-1': '#1D90BA' } },
  );
  if (!themeValuesObject) {
    themeValuesObject = { 'Secondary-1': '#1D90BA' };
  }
  const [activeId, setActiveId] = useState(0);
  const toggleActive = (id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };

  const previousState = location?.state?.previousState
    ? location?.state?.previousState
    : location?.state;
  const user = location.state.recordIndex && location.state.recordIndex;
  const providerUserDetails = async () => {
    try {
      const responseDocument = await axiosInstance.get(
        APIEndpoints.getProviderUserDetails() + '/oid/' + user.tempuseroid,
      );
      const response = responseDocument?.data.Response?.ProviderUser;
      setAffliationData(response);
      if (response?.IsDoctorFacility) {
        setDoctorFacilityFlag('doctor');
        const doctors = [];
        response?.UserProviderAffiliationDetails &&
          response?.UserProviderAffiliationDetails?.map((item) =>
            item?.FacilityDetails[0]?.PhysicianDetails.map((item) => {
              doctors.push(item);
            }),
          );
        setDoctorProvider(doctors);
      } else {
        setDoctorFacilityFlag('facility');
        setFacilityProvider(response?.UserProviderAffiliationDetails);
      }
      const configuration = await axiosInstance.get(`
      ${APIEndpoints.getProviderRegistrationConfiguration()}/mandatory/true/display/true/`);
      const permiconfig =
        configuration?.data?.Response?.selfProviderRegistrationDTO[0]
          ?.ProviderDefaultrole;
      setPermissions(permiconfig);
      setDataFetching(false);
    } catch (error) {
      console.log('error', error);
      setIsAPIFailed(true);
      setDataFetching(false);
      if (error?.response?.status === 404) {
        setIsNotFound(true);
      }
    }
  };
  const EditUserRequest = () => {
    navigate('/admin/edituser-request', {
      state: {
        affliationData: affliationData,
        doctorFacilityFlag: doctorFacilityFlag,
        recordIndex: location.state.recordIndex,
        preSelectedData:
          doctorFacilityFlag === 'doctor' ? doctorProvider : facilityProvider,
        previousState: { ...previousState },
      },
    });
  };
  const EditAffiliationRequest = () => {
    navigate('/admin/edit-affiliation-request', {
      state: {
        affliationData: affliationData,
        preSelectedData:
          doctorFacilityFlag === 'doctor' ? doctorProvider : facilityProvider,
        doctorFacilityFlag: doctorFacilityFlag,
        recordIndex: location.state.recordIndex,
        previousState: { ...previousState },
      },
    });
  };
  useEffect(() => {
    setDataFetching(true);
    providerUserDetails();
  }, []);
  const name = `${affliationData?.FirstName}${
    affliationData?.MiddleName ? ' ' + affliationData?.MiddleName + ' ' : ' '
  }${affliationData?.LastName}`;
  const buttonStatus = (value) => {
    if (value === 'Pending Approval') {
      return (
        <div className="d-flex ">
          <span>
            <ApprovalIcons.PendingSVG />
          </span>
        </div>
      );
    } else if (value === 'Approved') {
      return (
        <div className="d-flex">
          <span>
            <ApprovalIcons.ApprovedSVG />
          </span>
        </div>
      );
    } else {
      return (
        <div className="d-flex ">
          <span>
            <ApprovalIcons.DeniedSVG />
          </span>
        </div>
      );
    }
  };
  return (
    <>
      {dataFetching || !affliationData ? (
        <ApprovalDetailsSkeleton />
      ) : isAPIFailed ? (
        isNotFound ? (
          <div className="claims-no-data text-center">
            <CustomClientError
              CustomClasses="p-0 m-0"
              ErrorHeading="No Data found!"
              ErrorMessage="We could not find any Claims for the selected filter(s).
          Use another filter(s) and try again."
            />
          </div>
        ) : (
          <div className="claims-no-data text-center">
            <CustomClientError
              ErrorHeading="Something went wrong with request!"
              ErrorMessage="Please try again."
              CustomClasses="p-0"
            />
          </div>
        )
      ) : (
        affliationData && (
          <div className="approval-request-container">
            <div className="">
              <Header
                linkTo={'/admin/approvals'}
                header={`${affliationData?.FirstName}${
                  affliationData?.MiddleName
                    ? ' ' + affliationData?.MiddleName + ' '
                    : ' '
                }${affliationData?.LastName} - New Request`}
                preserveData={previousState}
              />
            </div>
            <div className="mt-3 request-info-panel">
              <div className="request-data">
                <ul className="flex-container">
                  <li className="flex-item">
                    <label>User</label>
                    <span>
                      {`${
                        affliationData?.FirstName
                          ? ' ' + affliationData?.FirstName + ' '
                          : ' '
                      }${
                        affliationData?.MiddleName
                          ? ' ' + affliationData?.MiddleName + ' '
                          : ' '
                      }${
                        affliationData?.LastName
                          ? ' ' + affliationData?.LastName + ' '
                          : ' '
                      }`}
                    </span>
                  </li>
                  <li className="flex-item">
                    <label>NPI</label>
                    <span>
                      {user.affiliations && user.affiliations.length > 0
                        ? user.affiliations[0].NPI === ''
                          ? '----'
                          : user.affiliations[0].NPI
                        : '----'}
                    </span>
                  </li>
                  <li className="flex-item">
                    <label>Request Type</label>
                    <span>{user.Subcategory}</span>
                  </li>
                  <li className="flex-item">
                    <label>Tax ID</label>
                    <span>
                      {user.affiliations && user.affiliations.length > 0
                        ? user.affiliations[0].TaxId === ''
                          ? '----'
                          : user.affiliations[0].TaxId
                        : '----'}
                    </span>
                  </li>
                  <li className="flex-item">
                    <label>Status</label>
                    <span>{buttonStatus(user?.status)}</span>
                  </li>
                  <li className="flex-item">
                    <label>Submitted On</label>
                    <span>{formatDate(user.createddate)}</span>
                  </li>
                </ul>
              </div>
              {user?.status === 'Pending Approval' && (
                <div className="request-control">
                  {/*<GenericButton className="pl-0 delete-cliteria-btn" variant="link">
            <DeleteIconSVG className={'deleteIconSVG'} /> Delete
          </GenericButton> */}
                  <GenericButton
                    className={`deny-button mr-3`}
                    variant={'error-secondary'}
                    onClick={() =>
                      deniedProviderData(
                        user?.Oid,
                        user?.tempuseroid,
                        null,
                        'details',
                        name,
                      )
                    }
                  >
                    DENY
                  </GenericButton>
                  <GenericButton
                    variant="primary"
                    onClick={() =>
                      approveProviderData(
                        user?.Oid,
                        user?.tempuseroid,
                        null,
                        'details',
                        name,
                      )
                    }
                  >
                    APPROVE
                  </GenericButton>
                </div>
              )}
            </div>
            <div className="mt-3 request-edit-panel">
              <div className="edit-section">
                <div className="user-label-edit-button">
                  <div className="user-label">
                    <span>User Profile</span>
                  </div>
                  {/*{user?.status === 'Pending Approval' && ( */}
                  {user?.status === 'Pending Approval' && (
                    <div>
                      <GenericButton
                        onClick={EditUserRequest}
                        variant="secondary"
                        className="height-32 edit-profile-button"
                      >
                        {' '}
                        <EditIcon
                          fillColor={
                            themeValuesObject['Secondary-1'] || '#1d90ba'
                          }
                        />{' '}
                        Edit{' '}
                      </GenericButton>
                    </div>
                  )}
                  {/*)} */}
                </div>
                <div className="top-section">
                  <div className="user-email">
                    <div className="user-icon">
                      {affliationData?.FirstName[0] +
                        affliationData?.LastName[0]}
                    </div>
                    <div className="name-email-container">
                      <div className="name">{`${
                        affliationData?.FirstName
                          ? ' ' + affliationData?.FirstName + ' '
                          : ' '
                      }${
                        affliationData?.MiddleName
                          ? ' ' + affliationData?.MiddleName + ' '
                          : ' '
                      }${
                        affliationData?.LastName
                          ? ' ' + affliationData?.LastName + ' '
                          : ' '
                      }`}</div>
                      <div className="email">{affliationData?.UserID}</div>
                    </div>
                  </div>
                  <div className="user-type-data-container">
                    <div className="heading">User Type</div>
                    <div className="data">
                      {affliationData?.UserType
                        ? affliationData?.UserType === 'Client'
                          ? 'Employer'
                          : affliationData?.UserType
                        : '-'}
                    </div>
                  </div>
                </div>
                <div className="horizantal-divide"></div>
                <div className="affliation">
                  <div className="user-label">
                    <span>Affiliation</span>
                  </div>
                  {user?.status === 'Pending Approval' && (
                    <div>
                      <GenericButton
                        onClick={EditAffiliationRequest}
                        variant="secondary"
                        className="height-32 edit-profile-button"
                      >
                        {' '}
                        <EditIcon
                          fillColor={
                            themeValuesObject['Secondary-1'] || '#1d90ba'
                          }
                        />{' '}
                        Edit{' '}
                      </GenericButton>
                    </div>
                  )}
                </div>
                <div className="affliation-accordion">
                  <Accordion defaultActiveKey="1">
                    <Card className="pb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        onClick={() => toggleActive(1)}
                        className="panel-toggle text-left w-100"
                        eventKey="1"
                      >
                        <div className="panel-card-header">
                          <div className="panel-card-text">
                            <div>
                              <span className="accordion-arrow">
                                {activeId === 1 ? (
                                  <AccordionUpArrow className="acc-arrow" />
                                ) : (
                                  <AccordionDownArrow className="acc-arrow" />
                                )}
                              </span>
                              <span className="accordion-name">
                                Provider(s)
                              </span>
                            </div>
                            {(doctorProvider?.length ||
                              facilityProvider?.length) && (
                              <span className="name-label">
                                {doctorFacilityFlag === 'doctor'
                                  ? doctorProvider?.length + ' Provider(s)'
                                  : facilityProvider?.length + ' Provider(s)'}
                              </span>
                            )}
                          </div>
                        </div>
                      </Accordion.Toggle>

                      <Accordion.Collapse eventKey="1">
                        <Card.Body className="mt-4 mb-2">
                          {doctorFacilityFlag === 'doctor' ? (
                            <div className="provider-affiliation-card">
                              {doctorProvider &&
                                doctorProvider.map((doctor, index) => {
                                  const Specialty =
                                    doctor?.Specialty &&
                                    doctor?.Specialty.split(',').map((item) =>
                                      item.trim(),
                                    );
                                  return (
                                    <div
                                      className="affliation-card"
                                      key={index}
                                    >
                                      <div className="flex-1 d-flex align-items-center">
                                        <div className=" provider-icon d-flex">
                                          <DoctorProviderIconSVG className="document_providericonsvg" />
                                        </div>
                                        <div className="name-provider">
                                          <div className="item-name">
                                            {`${doctor?.FirstName}${
                                              doctor?.MiddleName
                                                ? ' ' + doctor?.MiddleName + ' '
                                                : ' '
                                            }${doctor?.LastName}`}
                                          </div>
                                          <div className="item-speciality">
                                            <>
                                              {Specialty[0] && (
                                                <span>{Specialty[0]}</span>
                                              )}
                                              {Specialty[1] && (
                                                <span>, {Specialty[1]}</span>
                                              )}

                                              {Specialty.length > 2 && (
                                                <span className="addon">
                                                  {' '}
                                                  +{Specialty.length - 2}
                                                </span>
                                              )}
                                            </>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <div className="tax-npi pt-2 align-items-center">
                                          <div className="">
                                            NPI:{' '}
                                            {doctor?.Physician_NPI !== ''
                                              ? doctor?.Physician_NPI
                                              : '----'}
                                          </div>
                                          <div className="">
                                            <div className="">
                                              Tax ID:{' '}
                                              {doctor?.TaxID !== ''
                                                ? doctor?.TaxID
                                                : '----'}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          ) : (
                            <div className="provider-affiliation-card">
                              {facilityProvider &&
                                facilityProvider.map((facility, index) => {
                                  return (
                                    <div
                                      className="affliation-card"
                                      key={index}
                                    >
                                      <div className="flex-1 d-flex">
                                        <div className="provider-icon d-flex">
                                          <FacilityProviderIconSVG className="document_providericonsvg" />
                                        </div>
                                        <div className="name-provider-facility">
                                          <div className="item-name">
                                            {facility?.FacilityDetails[0]
                                              ?.FacilityName &&
                                              facility?.FacilityDetails[0]
                                                ?.FacilityName}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="tax-npi-facility">
                                        Tax ID:{' '}
                                        {facility?.FacilityDetails[0]?.TaxId &&
                                          facility?.FacilityDetails[0]?.TaxId}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          )}
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </div>
                <div className="horizantal-divide"></div>
                <div className="permission-header">
                  <div className="permission-label">Permission Group(s)</div>
                  {/*{user?.status === 'Pending Approval' && (
                  <div>
                    <GenericButton
                      onClick={onClickEditButton}
                      variant="secondary"
                      className="height-32 edit-profile-button"
                    >
                      {' '}
                      <EditIcon
                        fillColor={
                          themeValuesObject['Secondary-1'] || '#1d90ba'
                        }
                      />{' '}
                      Edit{' '}
                    </GenericButton>
                  </div>
                )} */}
                </div>
                <div className="permissions">
                  {permissions && (
                    <div className="permissions-card">
                      <span className="permissions-name">{permissions}</span>
                    </div>
                  )}
                </div>
                {user?.requestercomment && (
                  <>
                    <div className="horizantal-divide"></div>
                    <>
                      <div className="comments">Comments for approver</div>
                      <div className="comment-field">
                        <span className="text-feild">
                          {user?.requestercomment}
                        </span>
                      </div>
                    </>
                  </>
                )}

                {user?.status === 'Pending Approval' && (
                  <div className="request-control">
                    {/*<GenericButton className="pl-0 delete-cliteria-btn" variant="link">
            <DeleteIconSVG className={'deleteIconSVG'} /> Delete
          </GenericButton> */}
                    <GenericButton
                      className={` deny-button mr-3`}
                      variant={'error-secondary'}
                      onClick={() =>
                        deniedProviderData(
                          user?.Oid,
                          user?.tempuseroid,
                          null,
                          'details',
                          name,
                        )
                      }
                    >
                      DENY
                    </GenericButton>
                    <GenericButton
                      variant="primary"
                      onClick={() =>
                        approveProviderData(
                          user?.Oid,
                          user?.tempuseroid,
                          null,
                          'details',
                          name,
                        )
                      }
                    >
                      APPROVE
                    </GenericButton>
                  </div>
                )}
              </div>
              <div className="right-side-content"></div>
            </div>
            <div className="toastify">
              <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
            </div>
          </div>
        )
      )}
    </>
  );
};

export default ApprovalRequest;
